import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Mail, Copy } from "lucide-react";
import { Button } from "@/components/ui/button";
import { copyText } from "@/components/landing/ShareButtons";

export const LeadsManager = ({ client, API }) => {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    client.get(`${API}/admin/leads`).then((r) => setLeads(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, [client, API]);

  const copyEmails = async () => {
    const all = leads.map((l) => l.email).join(", ");
    if (await copyText(all)) toast.success(`${leads.length} email disalin`);
  };

  return (
    <div className="mt-16" data-testid="leads-manager">
      <div className="flex items-center justify-between gap-4 flex-wrap mb-2">
        <h2 className="font-display text-2xl tracking-tight flex items-center gap-3">
          <Mail className="w-5 h-5 text-[#A67C1E]" /> Lead Email ({leads.length})
        </h2>
        {leads.length > 0 && (
          <Button data-testid="copy-all-emails-btn" variant="outline" size="sm" onClick={copyEmails} className="border-[#A67C1E]/50 text-[#A67C1E] bg-transparent hover:bg-[#A67C1E]/10">
            <Copy className="w-3.5 h-3.5 mr-2" /> Salin Semua Email
          </Button>
        )}
      </div>
      <p className="text-sm text-[#211B10]/60 mb-6">Pengunjung yang mengisi form panduan gratis di /gratis — siap dihubungi atau diimpor ke layanan email.</p>
      {loading ? (
        <p className="text-sm text-[#211B10]/50">Memuat...</p>
      ) : leads.length === 0 ? (
        <p data-testid="leads-empty" className="text-sm text-[#211B10]/50 border border-[#211B10]/10 bg-white p-6">Belum ada lead. Sebarkan link {window.location.origin}/gratis untuk mulai mengumpulkan email.</p>
      ) : (
        <div className="border border-[#211B10]/10 bg-white overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-[#211B10]/10 font-mono text-[10px] uppercase tracking-[0.2em] text-[#211B10]/50 text-left">
                <th className="px-5 py-3">Nama</th>
                <th className="px-5 py-3">Email</th>
                <th className="px-5 py-3">Sumber</th>
                <th className="px-5 py-3">Email E-book</th>
                <th className="px-5 py-3">Tanggal</th>
              </tr>
            </thead>
            <tbody>
              {leads.map((l) => (
                <tr key={l.lead_id} data-testid={`lead-row-${l.lead_id}`} className="border-b border-[#211B10]/5 last:border-0">
                  <td className="px-5 py-3">{l.name}</td>
                  <td className="px-5 py-3 text-[#A67C1E]">{l.email}</td>
                  <td className="px-5 py-3 text-[#211B10]/60">{l.source}</td>
                  <td className="px-5 py-3">
                    {l.email_status === "terkirim" ? (
                      <span className="text-[#1B4332] font-mono text-[10px] uppercase tracking-wider">✓ Terkirim</span>
                    ) : l.email_status === "gagal" ? (
                      <span className="text-[#9B2C2C] font-mono text-[10px] uppercase tracking-wider">✕ Gagal</span>
                    ) : (
                      <span className="text-[#211B10]/40 font-mono text-[10px] uppercase tracking-wider">—</span>
                    )}
                    {l.followup_status === "terkirim" && (
                      <span className="block text-[#A67C1E] font-mono text-[10px] uppercase tracking-wider mt-1">✓ Follow-up H+3</span>
                    )}
                  </td>
                  <td className="px-5 py-3 text-[#211B10]/60">{new Date(l.created_at).toLocaleDateString("id-ID", { day: "numeric", month: "short", year: "numeric" })}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
